import useSWR from "swr";
import "./SidebarBands.scss";
import BandIcon from "./icons/BandIcon";
import IconContainer from "./icons/IconContainer";
import SoloIcon from "./icons/SoloIcon";

const fetcher = (...args) => fetch(...args).then((res) => res.json());

function SidebarBand({
  band,
  setShowBandDetails,
  setSidebarOpen,
  setSelectedBand,
}) {
  const url = `/api/zipcodes/${band.zipcode}`;
  const { data: zipcode } = useSWR(url, fetcher);

  const handleMoreInformationClick = () => {
    setSidebarOpen(true);
    setShowBandDetails(true);
    setSelectedBand(band);
  };

  return (
    <button className="button" onClick={handleMoreInformationClick}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <div>
          <IconContainer color={band.type === "band" ? "#009FE3" : "#DD0078"}>
            {band.type === "band" ? <BandIcon /> : <SoloIcon />}
          </IconContainer>
        </div>
        <div>
          <p className="band-name">{band?.name}</p>
          <p className="band-description">{band?.type}</p>
          <p className="band-description">{zipcode?.label}</p>
        </div>
      </div>
    </button>
  );
}

export default SidebarBand;
